<template lang="pug">
  ods-module.consultDetail
    .consul__header
        .flex-container.align-center.consultDetail__back
            ods-button(
                @click="handleClick"
                type="text"
                icon="ods-icon-arrow-left")
            p.tp-m-deci.ods-breadcrumb__separator {{ this.$t('commerceInfo.invoice') }}
        filter-table(
          layout="text, actions"
          @inputSearchFilter="inputSearchFilter")
        //- .flex-container.space-between.align-center.consultDetail__search
        //-     .flex-container.align-center
        //-       ods-input-search(
        //-         size='hecto'
        //-         outlined
        //-         placeholder='Buscar'
        //-         @input='facturacionSearch')
        //-     .flex-container.align-center
        //-       ods-actions-menu(
        //-         customClass="card-menu"
        //-         icon="overflow-menu"
        //-         color="#888A91"
        //-         size="18"
        //-         popoverPosition="bottom-end")
        //-         ul.menu
        //-           li.menu__item
        //-             a(href="#" @click.prevent="showExport = true")
        //-               ods-icon(name="file_export" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
        //-               | Exportar
        //-           li.menu__item
        //-             a(href="#" @click.prevent="")
        //-               ods-icon(name="print" color="#B6B6B6" size="24" style="vertical-align: middle").ods-mr-2
        //-               | Imprimir
    ods-table(
      v-loading="loadingTable"
      style='width: 100%'
      :data='tableDataRendered'
      :default-sort = "{prop: 'fremesa', order: 'descending'}"
      )
      ods-table-column(prop='fecfac' label='Fecha - Hora' sortable)
        template(slot-scope="scope")
          div {{ scope.row.fecfac | formatDateLocale }} - {{ scope.row.horfac }}
      ods-table-column(prop='numreffacrem' label='Referencia' sortable)
      ods-table-column(prop='destipfac' label='Tipo de operacion' sortable)
      ods-table-column(prop='pan' label='Tarjeta' sortable)
      ods-table-column(prop='impfac' label='Nominal' sortable)
        template(slot-scope="scope")
          div {{ scope.row.impfac | toCurrencyCode(scope.row.clamon) }}
      ods-table-column(prop='impdes' label='Descuento' sortable)
        template(slot-scope="scope")
          div {{ scope.row.impdes | toCurrencyCode(scope.row.clamon) }}

    div.footer
      paginator(
        :isNextPage="indMasDatos"
        :currentPage="currentPage"
        @buttonPrevAction="getPrevPage"
        @buttonNextAction="getNextPage")
    //- ods-pagination(
    //-   :page-sizes='[5, 10, 50, 100]',
    //-   :page-size="itemsPerPage",
    //-   layout='prev, pager, next',
    //-   :total='totalData'
    //-   @size-change='handleSizeChange',
    //-   @current-change='handleCurrentChange'
    //-   style="text-align: right; margin-top: 20px")

</template>

<script>
import { mapGetters } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'FacturacionTable',

  components: {
    FilterTable,
    Paginator
  },

  data () {
    return {
      defaultParams: {
        codcom: this.$route.params.comercio ? this.$route.params.comercio.codcom : '',
        numrefrem: this.$route.params.numrefrem
      },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false
    }
  },

  computed: {
    ...mapGetters([
      // 'itemsPerPage'
    ])
  },

  methods: {
    handleClick () {
      this.$router.push({
        name: 'Commerce',
        path: `/commerce/${this.$route.params.comercio.registro_Numero}`,
        params: {
          id: this.$route.params.id,
          comercio: this.$route.params.comercio
        }
      })
    },

    // loadInvoices () {
    //   this.$store.dispatch('listInvoices', { codcom: this.$route.params.comercio.codcom, numrefrem: this.$route.params.numrefrem })
    //     .then((res) => {
    //       this.data = res
    //       this.totalData = res.length
    //       // this.handlePagination()
    //     })
    // },

    async getData (params) {
      this.loadingTable = true
      // Listado de Consultas - Ver facturas
      await this.$store.dispatch('listInvoices', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
          // this.totalData = res.length
          // this.handlePagination()
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.destipfac.toLowerCase().includes(text.toLowerCase()) ||
          res.impfac.toString().toLowerCase().includes(text.toLowerCase()) ||
          res.impfac.toString().replace('.', ',').toLowerCase().includes(text.toLowerCase())
      })
    }

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // }
  },

  beforeMount () {
    // this.loadInvoices()
  },

  mounted () {
    if (this.$route.params.numrefrem) {
      this.getInitialData()
      // this.handlePagination()
      this.$route.params.commerce = sessionStorage.getItem('descComercio')
      this.$route.params.chain = sessionStorage.getItem('descCadena')
    } else {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}
.consultDetail{
    &__back{
        margin-bottom: 30px;
    }
    &__search{
        margin-bottom: 30px;
    }
    padding: 30px;
    // background: #fff;
    margin: 40px;
    .ods-button--text{
        padding: 0;
    }
}
</style>
